import styled from "styled-components";

export const StyledIframe = styled.iframe`
  border: none;
  border-radius: 8px;
`;
